"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _index = _interopRequireDefault(require("@/components/Pagination/index"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _lang = _interopRequireDefault(require("@/lang"));

var _vuex = require("vuex");

var _dateformart = require("@/utils/dateformart");

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "currencyExchangeRate:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _index.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      controllerPath: "currencyExchangeRate",
      buttonLoading: false,
      tableKey: 0,
      list: [],
      // gatewayList: null,
      total: 0,
      listLoading: true,
      addDialogVisible: false,
      // timeList: [getTodayBegin(), getNowLessOneSecond()],
      timeList: [],
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        currencyFrom: "",
        currencyTo: "",
        apiUpdateState: ""
      },
      addInformationParameter: {
        id: null,
        currencyFrom: "",
        currencyTo: "",
        rate: "",
        apiUpdateState: "0",
        updateTime: ""
      },
      downloadLoading: false,
      updatePayChannelFlag: false,
      multipleSelection: [],
      rules: {
        currencyFrom: [{
          required: true,
          message: _lang.default.t("channel.currencyFromText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        currencyTo: [{
          required: true,
          message: _lang.default.t("channel.currencyToText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        rate: [{
          required: true,
          message: _lang.default.t("channel.currencyRateText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['currencyTypeOption', 'currencyExchangeRateUpdateStateOptions'])),
  created: function created() {
    // this.initList();
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      //Set the loading button for table
      this.listLoading = true; //Get search parameters

      var params = this.getQueryParams();

      _httpUtils.default.post(this.controllerPath, "list", null, params).then(function (res) {
        _this2.list = res.data.rows;
        _this2.total = res.data.total;
      }).finally(function () {
        _this2.listLoading = false;
      });
    },
    //Get search parameter for backend service
    getQueryParams: function getQueryParams() {
      // let updateStartTime = getTodayBegin()
      // let updateEndTime = getNowLessOneSecond();
      var updateStartTime = null;
      var updateEndTime = null;

      if (this.timeList && this.timeList.length > 0) {
        updateStartTime = this.timeList[0];
        updateEndTime = this.timeList[1];
      } // else{
      //   this.timeList= [];
      //   this.timeList.push(updateStartTime);
      //   this.timeList.push(updateEndTime);
      // }


      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        currencyFrom: this.queryParameter.currencyFrom,
        currencyTo: this.queryParameter.currencyTo,
        apiUpdateState: this.queryParameter.apiUpdateState,
        updateStartTime: updateStartTime,
        updateEndTime: updateEndTime
      };
    },
    //Refresh table
    handleFilter: function handleFilter() {
      //Reset the page number of table
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    //Get input parameters for backend service
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        id: this.addInformationParameter.id,
        currencyFrom: this.addInformationParameter.currencyFrom,
        currencyTo: this.addInformationParameter.currencyTo,
        rate: this.addInformationParameter.rate,
        apiUpdateState: this.addInformationParameter.apiUpdateState
      };
    },
    //Fill in parameters for updating currency exchange rate
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.addInformationParameter.id = row.id;
      this.addInformationParameter.currencyFrom = row.currencyFrom;
      this.addInformationParameter.currencyTo = row.currencyTo;
      this.addInformationParameter.apiUpdateState = row.apiUpdateState;
      this.addInformationParameter.rate = row.rate;
      this.addDialogVisible = true;
      this.updateChannelFlag = true;
    },
    handleAdd: function handleAdd() {
      var _this3 = this;

      // this.addNotedDialogVisible = false;
      var _this = this;

      this.$refs["addInformation"].validate(function (valid) {
        if (valid) {
          var params = _this.getAddInformationParameter();

          var action;

          if (_this.updateChannelFlag) {
            action = "update";
          } else {
            action = "add";
          }

          if (_this3.controllerPath && action) {
            _httpUtils.default.post(_this3.controllerPath, action, null, params).then(function (res) {
              if (res.code === 200) {
                if (action === "add") {
                  _this3.$message({
                    message: _lang.default.t("warningMessage.addCurrencyExchangeRateSuccessMessage"),
                    type: "success"
                  });
                }

                if (action === "update") {
                  _this3.$message({
                    message: _lang.default.t("warningMessage.updateCurrencyExchangeRateSuccessMessage"),
                    type: "success"
                  });
                }
              }

              _this3.handleResetAdd();

              _this3.handleFilter();
            }).catch(function (e) {
              _this3.$message({
                message: e.message,
                type: "error"
              });
            });
          }

          _this3.$refs["addInformation"].clearValidate();
        } else {
          return false;
        }
      });
    },
    //Clear input parameters
    handleReset: function handleReset() {
      this.addNotedDialogVisible = false;
      this.remarkMessage = "";

      if (!this.updateChannelFlag) {
        this.addInformationParameter.id = null;
      }

      this.addInformationParameter.currencyFrom = "";
      this.addInformationParameter.currencyTo = "";
      this.addInformationParameter.rate = "";
      this.addInformationParameter.apiUpdateState = "0";
    },
    //Reset validate for input parameters
    handleResetAdd: function handleResetAdd() {
      var _this4 = this;

      this.addDialogVisible = false;
      this.updateChannelFlag = false;
      this.handleReset();
      this.$nextTick(function () {
        _this4.$refs["addInformation"].clearValidate();
      });
    },
    deleteGroup: function deleteGroup(groupIds) {
      var _this5 = this;

      _httpUtils.default.post(this.controllerPath, "batchDelete", null, groupIds).then(function (res) {
        _this5.$message({
          message: _lang.default.t("warningMessage.deleteRecordSuccessMessage"),
          type: "success"
        });

        _this5.handleFilter();
      }).catch(function (err) {
        _this5.$message({
          message: err.message,
          type: "error"
        });
      });
    },
    handleDelete: function handleDelete(id) {
      var _this6 = this;

      this.$confirm(_lang.default.t("warningMessage.deleteRecordConfirmMessage"), _lang.default.t("warningMessage.deleteRecordMessage"), {
        confirmButtonText: _lang.default.t("common.confirm"),
        cancelButtonText: _lang.default.t("common.cancel"),
        type: "warning"
      }).then(function () {
        var ids = [];
        ids.push(id);

        _this6.$nextTick(function (_) {
          _this6.deleteGroup(ids);
        });
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this7 = this;

      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectRecordToDeleteMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.deleteRecordConfirmMessage"), _lang.default.t("warningMessage.deleteRecordMessage"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          var ids = [];

          for (var item in _this.multipleSelection) {
            ids.push(_this.multipleSelection[item].id);
          }

          _this7.$nextTick(function (_) {
            _this7.deleteGroup(ids);
          });
        }).catch(function (_) {});
      }
    },
    updateByApi: function updateByApi(ids) {
      var _this8 = this;

      _httpUtils.default.post(this.controllerPath, "updateCurrencyExchangeRateByApiForExchangeRateIds", null, ids).then(function (res) {
        _this8.$message({
          message: _lang.default.t("warningMessage.updateCurrencyExchangeRateSuccessMessage"),
          type: "success"
        });

        _this8.handleFilter();
      }).catch(function (err) {
        _this8.$message({
          message: err.message,
          type: "error"
        });
      });
    },
    //Fill in parameters for updating currency exchange rate
    handleUpdateByApi: function handleUpdateByApi() {
      var _this9 = this;

      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectCurrencyExchangeRateToUpdateMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.updateCurrencyExchangeRateMessage"), _lang.default.t("warningMessage.updateCurrencyExchangeRateTitle"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          var ids = [];

          for (var item in _this.multipleSelection) {
            ids.push(_this.multipleSelection[item].id);
          }

          _this9.$nextTick(function (_) {
            _this9.updateByApi(ids);
          });
        }).catch(function (_) {});
      }
    },
    //Convert currency
    convertCurrencyCodeToName: function convertCurrencyCodeToName(val) {
      if (!this.currencyTypeOption || !this.currencyTypeOption.length) return;
      var currency = this.currencyTypeOption.find(function (currency) {
        return currency.key === val;
      });

      if (currency) {
        return currency.display_name;
      } else {
        return "";
      }
    },
    //Convert currency
    convertUpdateStateCodeToName: function convertUpdateStateCodeToName(val) {
      if (!this.currencyExchangeRateUpdateStateOptions || !this.currencyExchangeRateUpdateStateOptions.length) return;
      var state = this.currencyExchangeRateUpdateStateOptions.find(function (state) {
        return state.key === val;
      });

      if (state) {
        return state.display_name;
      } else {
        return "";
      }
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;